import React,{
  useCallback,
  useContext,useEffect,useRef,useState,
} from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { makeStyles,Modal,Button,Select,FormControl,InputLabel } from '@material-ui/core';
import { withSnackbar } from 'notistack';
import Toolbar from './Toolbar';
import { readMetauser,readRecordedSentences } from '../../db';
import SideBar from './SideBar';
import Authenticated from '../../_authenticated';
import Context from '../../Context';
import Prerecorded from './Prerecorded';
import Reader from '../../reader';
import sentry from '../../sentry';
import UtteranceBox from './UtteranceBox';
import CountdownAlert from './CountdownAlert';
import { RecordingInfo } from './RecordingInfo';
import { getModalStyle } from '../../utils';
import { useNavigate } from 'react-router-dom';


const useStyles = makeStyles(theme => ({
  container: {
    [theme.breakpoints.down(`md`)]: {
      maxWidth: `100%`,
      paddingRight: `250px`,
    },
    [theme.breakpoints.down(`sm`)]: { marginTop: `50px` },
    [theme.breakpoints.down(`xs`)]: { paddingRight: `16px` },
  },
  prerec: {
    // margin: `5px 50px`,
    [theme.breakpoints.down(`sm`)]: { margin: `5px` },
  },
  readTitle: {
    fontStyle: `italic`,
    [theme.breakpoints.down(`sm`)]: { fontSize: `20px` },
  },
  reportBtn: {
    color: `blue`,
    marginLeft: `auto`,
    marginTop: `0.5rem`,
    cursor: `pointer`,
  },
  paper: {
    position: `absolute`,
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: `2px solid #000`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2,4,3),
  },
  reportSubmitButton: { marginTop: `2rem` },
  leftPadded: { marginLeft: `1rem` },
}));

class ProblematicPhrase extends Error {
  constructor(message) {
    super(message);
    this.name = `ProblematicPhrase`;
  }
}


export default withSnackbar(({ enqueueSnackbar }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  useEffect(() => {
    window.addEventListener(`storage`,e => {
      if (e.key === `groupId`) navigate(`/`);
    });
  },[]);

  const [modalStyle] = useState(getModalStyle);

  // Context group var and app loading status
  const { group,loading,user } = useContext(Context);

  // Set current metauser information from DynamoDB
  const [meta,setMeta] = useState();

  // Set current accepted utterances
  const [recordings,setRecordings] = useState(null);

  // Store current sentence
  const [sentence,setSentence] = useState({ });

  // And current recorded rawAudio (blob format)
  const [rawAudio,setRawAudio] = useState();
  const [s3audio,setS3Audio] = useState();
  const [status,setStatus] = useState();
  const [completeRecording,setCompleteRecording] = useState(null);

  // Set if there will be no next sentence to read, a response from dynamoDB querying sentences
  const [last,setLast] = useState(false);

  // Send recording to queue bar
  const [sendAudio,setSendAudio] = useState();

  // Have a local queue for failed recordings, to use after all sentences are read.
  const [queue,setQueue] = useState([]);

  // Load next phrase to speed up usability
  const preloadData = useRef();

  // Put current audio in buffer if some other replaces it
  const bufferLoaded = useRef();

  // store a constant about sentence reader
  const reader = useRef();

  // Store all recordings
  const recordingsSafe = useRef([]);

  // Target duration
  const [targetDuration,setTargetDuration] = useState(0);

  const [targetPlayed,setTargetPlayed] = useState(false);

  const [notSupported,setNotSupported] = useState(false);

  const [searching,setSearching] = useState(false);

  const [isReporterOpen,setIsReporterOpen] = useState(false);
  const [isReported,setIsReported] = useState(false);

  const [toRecord,setToRecord] = useState(null);

  const [reason,setReason] = useState(null);

  const [retryCount,setRetryCount] = useState(0);

  const [tooManyTriesWarning,setTooManyTriesWarning] = useState(false);

  const [skipModalIsOpen,setSkipModalIsOpen] = useState(false);

  const resetRecordedAudio = useRef(null);

  const openSkipModal = resetAudioFnCb => {
    setSkipModalIsOpen(true);
    resetRecordedAudio.current = resetAudioFnCb;
  };

  const closeSkipModal = () => {
    setSkipModalIsOpen(false);
  };

  const preLoad = useCallback(() => {
    if (preloadData.current || last) return;
    const ans = reader.current(recordingsSafe);
    // Check if this is random and already recorded
    preloadData.current = ans;
  },[reader,last]);

  const nextPhrase = useCallback(() => {
    setRetryCount(0);
    if (preloadData.current) {
      setSentence(preloadData.current.sentence);
      if (!preloadData.current.lastId) {
        preloadData.current = null;
        setLast(true);
      } else {
        preloadData.current = null;
        preLoad();
      }
      return;
    }
    try {
      const ans = reader.current(recordingsSafe);
      setSentence(ans.sentence);
      if (!ans.lastId) 
        setLast(true);
      else 
        preLoad();
      
    } catch (err) {
      sentry(err);
      setSentence({ phrase: `Error` });
      enqueueSnackbar(`Cant load more utterances, please reload the application`,{ variant: `error`,autoHideDuration: 10000 });
    }
  },[preloadData,setSentence,preLoad,enqueueSnackbar]);

  useEffect(() => {
    if (!loading && user && group) {
      if (MediaRecorder.notSupported) {
        enqueueSnackbar(`Your browser may not support mic capturing, please try another browser`,{ variant: `error`,persist: true });
        setNotSupported(true);
      }
      readMetauser().then(u => {
        setMeta(u);
        setTimeout(() => {
          if (!reader.current) 
            enqueueSnackbar(`This first load may take some seconds, please wait`,{ variant: `info` });
          
        },3000);
        readRecordedSentences().then(resp => {
          setRecordings(resp);
          Reader(group,resp,setToRecord).then(fn => {
            reader.current = fn;
            nextPhrase();
          });
        }).catch(() => {
          Reader(group,[]).then(fn => {
            reader.current = fn;
            nextPhrase();
          });
        });
      }).catch(sentry);
    }
  },[loading,user,group]);

  const setRecording = rec => {
    if (queue.length || sentence.id === rec.sentence.id) 
      bufferLoaded.current = null;
    else 
      bufferLoaded.current = { rawAudio,sentence };
    
    setRawAudio(rec.rawAudio || null);
    setSentence(rec.sentence);
    setS3Audio(rec.s3audio || null);
    setStatus(rec.status);
    setCompleteRecording(rec);
  };

  const goNext = () => {
    setIsReported(false);
    setStatus(null);
    setCompleteRecording(null);
    if (queue.length) {
      const q = [...queue];
      const rec = q.shift();
      setQueue(q);
      setRecording(rec);
    } else if (bufferLoaded.current) {
      setRawAudio(bufferLoaded.current.rawAudio);
      setSentence(bufferLoaded.current.sentence);
      setS3Audio(null);
      bufferLoaded.current = null;
    } else if (!last) {
      setSentence({ loading: true });
      nextPhrase();
    } else {
      setSentence({ finished: true });
      enqueueSnackbar(`You completed all utterances!`,{ variant: `success` });
    }
  };

  const toggleReport = () => {
    setIsReported(val => !val);
  };

  const submitReport = () => {

    const report = new ProblematicPhrase(`Problematic reference`);
    report.message = `${sentence.id}:${reason}:${sentence.phrase}`;
    sentry(report);
  };

  const skipCurrentPhrase = () => {
    goNext();
  };

  const closeTooManyTriesWarningModal = () => {
    setTooManyTriesWarning(false);
  };

  const renderTooManyTriesWarning = () => {
    return (
      <>
        <div style={modalStyle} className={classes.paper}>
          <h2 id="simple-modal-title">Sanas’s acceptance criteria are not perfect and the prompts may be inherently problematic. We advise that it would be best to skip this utterance and continue with the other utterances. </h2>
          <Button onClick={skipCurrentPhrase} variant="outlined" title="Submit and Skip">
            Skip
          </Button>
          <Button className={classes.leftPadded} onClick={closeTooManyTriesWarningModal} variant="outlined" title="Submit and Skip">
            Cancel
          </Button>
         
        </div>
      </>
    );
  };

  const handleRetry = () => {
    setRetryCount(v => {
      console.log(`Number of re-tries done = ${v}`);
      if(v === 2) {
        // setTooManyTriesWarning(true);
        goNext();
        return 0;
      }
      return v + 1;
    });
    
  };

  const submitProblematicReport = () => {
    if(isReported) submitReport();
  };

  return (
    <Authenticated>
      <div style={{ marginRight: `200px` }}>
        {/* {skipModalIsOpen && <SkipReasonModal open={skipModalIsOpen} handleClose={closeSkipModal} sentence={sentence} handleNext={goNext} />} */}
        <SideBar
          onFailureBNFCriteria={handleRetry}
          queue={queue}
          currentSentence={sentence}
          sendAudio={sendAudio}
          setSendAudio={setSendAudio}
          meta={meta}
          dbRecordings={recordings}
          setMeta={setMeta}
          group={group}
          setRecording={setRecording}
          setSearching={setSearching}
          recordingsSafe={recordingsSafe} 
          handleNextPhrase={goNext}
          skipModalIsOpen={skipModalIsOpen}
          closeSkipModal={closeSkipModal}
          resetRecordedAudio={resetRecordedAudio.current}
          sentence={sentence}
          completeRecording={completeRecording}
          toRecord={toRecord}/>
        <Container maxWidth="md" className={classes.container}>

          <Box my={4}>
            <Typography variant="h5" component="h1" align="center" gutterBottom className={classes.readTitle}>
              Read the sentences:
            </Typography>
            <RecordingInfo sentence={sentence}/>
            <div style={{ display: `flex`,height: `3rem` }}>
              
              <Typography component="h1" className={classes.reportBtn} onClick={toggleReport}>
                <img src={!isReported ? `/blank_flag.png` : `/red_flag.png` } style={{ height: `1.5rem`,marginLeft: `1rem` }} />
              </Typography>
              
            </div>

            <Modal
              open={tooManyTriesWarning}
              aria-labelledby="too-many-tries-warning"
              aria-describedby="too-many-tries-warning">
              {renderTooManyTriesWarning()}
            </Modal>


            <CountdownAlert group={group} meta={meta} />

            <UtteranceBox sentence={sentence} status={status} />

            <div className={classes.prerec}>
              <Prerecorded
                sentence={sentence}
                setDuration={setTargetDuration}
                setPlayed={setTargetPlayed}
                goNext={goNext}
                meta={meta}
                group={group}
                preloadSentence={preloadData.current && preloadData.current.sentence}/>
            </div>

            {!notSupported && (
              <Toolbar
                onRetry={handleRetry}
                submitProblematicReport={submitProblematicReport}
                goNext={goNext}
                setSendAudio={setSendAudio}
                disableNext={last && queue.length === 0}
                forceTarget={group && group.forceTarget && !targetPlayed && (!s3audio && !rawAudio)}
                forceBNFCheck={group ? group.forceBNFCheck : false} 
                sentence={sentence}
                rawAudio={rawAudio}
                setRawAudio={setRawAudio}
                targetDuration={targetDuration}
                s3audio={s3audio}
                openSkipModal={openSkipModal}
                searching={searching}/>
            )}

          </Box>
        </Container>
      </div>

    </Authenticated>
  );
});
